import { SET_ENCRYPTED_KEY } from '.';

export default key => dispatch => {
  dispatch({
    type: SET_ENCRYPTED_KEY,
    payload: { key },
  });
};
